import { SOLD_OUT_STATUS } from '../constants';

export const isOfferSoldout = offer => offer?.status === SOLD_OUT_STATUS;
